module.exports = "https://portperrypedals.ca/_res/img/new-ct-in-suite.80be0d9.jpg";